import {PersonnelDocumentTitle} from 'src/app/personnel/personnelHelpers';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';
import {
  ModuleEnum,
  PermissionOperationEnum,
  UserTypeEnum,
} from 'src/api/ProactApiClient';
import type {PersonnelViewType} from 'src/shared/constants/ViewTypes';
import {PersonnelForm} from 'src/app/personnel/PersonnelForm/PersonnelForm';
import type {ViewModeType} from 'src/shared/services/RouterService/IRouteService';
import {PersonnelRouteService} from 'src/shared/services/RouterService/PersonnelRouteService';

import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';

export const CreatePersonnelPage = () => {
  useSetDocumentTitle(PersonnelDocumentTitle);

  const mode: ViewModeType = 'create';
  const router = new PersonnelRouteService(false, mode, {
    view: 'overview' as PersonnelViewType,
  });

  return (
    <PersonnelForm
      mode="create"
      userType={UserTypeEnum.Employee}
      view={'overview'}
      enableEdit={true}
      router={router}
    />
  );
};

export default CreatePersonnelPage;

// Register the route with the new system
routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.PersonnelCreate(),
  element: <CreatePersonnelPage />,
  module: ModuleEnum.Personnel,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
});
